import { render, staticRenderFns } from "./kpi-tags.vue?vue&type=template&id=27d4e6ac&"
import script from "./kpi-tags.vue?vue&type=script&lang=js&"
export * from "./kpi-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports